<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @task="taskFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.settingName"
              placeholder="请输入兑换名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.consumerName"
              placeholder="请输入用户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入用户电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-select
              v-model="masterList.tableQuery.search.isExpress"
              placeholder="请选择是否邮寄"
              clearable
              style="width:100%"
            >
              <el-option
                :value="1"
                label="是"
              />
              <el-option
                :value="0"
                label="否"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun()"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @exportZip="batchExportZip(masterList)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 导出 batchExportZipMixin
import batchExportZipMixin from '@/mixin/batchExportZipMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadAppConsumerIntegralExchangeRewardListDataApi, loadAppConsumerIntegralExchangeRewardExportDataApi, findAppConsumerIntegralExchangeRewardCountByConditionApi, loadAppConsumerIntegralExchangeRewardExportPicZipApi } from '@/api/appConsumerIntegralExchangeReward'

export default {
  name: 'AppConsumerIntegralExchangeReward',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin, batchExportZipMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_integral_exchange_reward_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_integral_exchange_reward_add'],
            prop: 'add',
            label: '新增兑换中奖信息',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_integral_exchange_reward_edit'],
            prop: 'edit',
            label: '录入邮寄信息',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_integral_exchange_reward_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_integral_exchange_reward_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['app_user_integral_exchange_reward_export'],
            prop: 'exportZip',
            label: '导出图片',
            method: 'exportZip'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            settingName: '',
            consumerName: '',
            isExpress: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      // 待办
      todoList: [
        {
          permissionSigns: ['app_user_integral_exchange_setting_publish'],
          label: '待录入邮寄的兑换中奖记录',
          method: 'task',
          count: 0
        }
      ]
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'consumerId', filterColumn: 'r.id', label: '消费者编号', width: 120 },
      { prop: 'consumerName', filterColumn: 'r.name', label: '消费者名称', width: 120 },
      { prop: 'phone', filterColumn: 'r.phone', filterValue: 'phone', label: '电话', width: 120 },
      { prop: 'address', filterColumn: 'r.address', label: '地址', width: 120 },
      { prop: 'settingName', filterColumn: 's.name', label: '奖品名称', width: 160 },
      { prop: 'settingSortStr', filterColumn: 's.sort', filterValue: 'settingSort', label: '活动类型', width: 120, filterArray: [{ label: '扫码积分', value: 1 }, { label: '扫码抽奖', value: 2 }] },
      { prop: 'exchangeTimeStr', filterColumn: 'i.exchange_time', label: '兑换中奖时间', width: 160, isBetween: true },
      { prop: 'storeName', filterColumn: 'store.store_name', label: '门店名称', width: 160 },
      { prop: 'amount', filterColumn: 'i.amount', label: '奖品数量', width: 120 },
      { prop: 'integral', filterColumn: 'i.integral', label: '兑换积分', width: 120 },
      { prop: 'abnormalStatusStr', filterColumn: '(case l.status when 1 then \'异常扫码\' else \'\' end)', label: '异常状态', width: 120 },
      { prop: 'isExpressStr', filterColumn: 'i.is_express', filterValue: 'isExpress', label: '是否邮寄', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'expressDateStr', filterColumn: 'i.express_date', label: '邮寄日期', width: 140, isBetween: true },
      { prop: 'expressName', filterColumn: 'i.express_name', label: '快递公司', width: 120 },
      { prop: 'expressNo', filterColumn: 'i.express_no', label: '快递单号', width: 160 },
      { prop: 'expressUserName', filterColumn: 'i.express_user_name', label: '寄件人', width: 120 },
      { prop: 'expressFee', filterColumn: 'i.express_fee', label: '邮寄费用', width: 120 },
      { prop: 'expressStatusStr', filterColumn: 'i.express_status', filterValue: 'expressStatus', label: '物流状态', width: 120, filterArray: [{ label: '已揽件', value: 0 }, { label: '运输中', value: 1 }, { label: '运输中', value: 2 }, { label: '已签收', value: 3 }, { label: '派送失败', value: 4 }, { label: '疑难件', value: 5 }, { label: '退件签收', value: 6 }] },
      { prop: 'isSignStr', filterColumn: 'i.is_sign', filterValue: 'isSign', label: '是否签收', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'lastExpressStatus', filterColumn: 'i.last_express_status', label: '最新物流信息', width: 160 },
      // { prop: 'expressResult', filterColumn: 'i.express_result', label: '全部物流信息', width: 160 },
      { prop: 'remark', filterColumn: 'i.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'i.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'i.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerIntegralExchangeRewardListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        data.forEach(item => {
          if (item.abnormalStatus === 1) {
            item.fontColor = 'red'
          }
        })
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      let params = { isExpress: 0 }
      findAppConsumerIntegralExchangeRewardCountByConditionApi(params).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    // 待发布
    taskFun () {
      this.masterList.tableQuery.search.consumerName = ''
      this.masterList.tableQuery.search.settingName = ''
      this.masterList.tableQuery.search.isExpress = 0
      this.loadTableData()
    },
    addFun () {
      this.id = null
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增兑换中奖信息'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].isExpress !== 0) {
        this.$message({
          message: '已录入邮寄信息，不能操作',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '录入邮寄信息'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看兑换中奖信息'
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerIntegralExchangeRewardExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    },
    // 导出数据API
    ExportZipByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportZipObj) }
      loadAppConsumerIntegralExchangeRewardExportPicZipApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
